import React, { useMemo } from "react";
import SelectComponent from "react-select";

interface ISelectProps {
  name: string;
  values?: any;
  placeholder?: any;
  options?: any;
  onChange?: any;
  getOptionLabel?: any;
  getOptionValue?: any;
  disabled?: any;
  errors?: any;
  touches?: any;
  onBlur?: any;
  onKeyDown?: any;
  backgroundColor?: any;
  defaultValue?: any;
  label?: string;
  className?: string;
}

export function Select(props: ISelectProps) {
  const isInvalid = useMemo(() => {
    return props?.touches?.[props?.name] &&
      !props?.values?.[props?.name] &&
      props?.errors?.[props?.name]
      ? true
      : null;
  }, [props?.touches, props?.errors, props?.name]);
  return (
    <div className='flex flex-col w-full gap-2 relative'>
      <label className={`text-[11px] font-bold text-Black w-full`}>
        {props?.label}
      </label>
      <SelectComponent
        isClearable
        isSearchable
        placeholder={props?.placeholder}
        options={props?.options}
        defaultValue={props?.values?.[props?.name]}
        name={props?.name}
        onChange={props?.onChange}
        getOptionLabel={(option: any) => option?.[props?.getOptionLabel]}
        getOptionValue={(option: any) => option?.[props?.getOptionValue]}
        onKeyDown={props?.onKeyDown}
        isDisabled={props?.disabled}
        theme={(theme: any) => ({
          ...theme,
          borderRadius: 5,

          colors: {
            ...theme.colors,

            text: "#0F1A2D",
            primary25: "#E5E7EB",
            primary50: "#E5E7EB",

            primary: "#939393",
          },
        })}

        className={["text-xs border relative border-gray-300 rounded-md text-textGray w-full", props.className]
          .filter(Boolean)
          .join(" ")}
        //className={["text-xs border bg-white border-gray-200 rounded-md text-textGray w-full" props.className]}
        styles={{
          control: () => ({
            display: "flex",
            backgroundColor: props?.backgroundColor
              ? props?.backgroundColor
              : "#fff",
            borderRadius: "5px",
          }),
        }}
        // menuPortalTarget={document.body}
      />
      {isInvalid ? (
        <div
          style={{ color: "#ef4444" }}
          className='font-bold text-[10px] mt-1 h-9 w-full absolute top-16'
        >
          {props?.label ? props?.label : props?.name} is required
        </div>
      ) : null}
    </div>
  );
}
